<template>
  <div>
    <v-btn
      v-if="item.counter > 0"
      text
      color="primary"
      class="text-decoration-underline"
      @click="dayCountClickEvent"
    >
      {{ item.counter }}
    </v-btn>
    <span v-else>
      -
    </span>
    <driver-schedule-dialog
      :enable-dialog="enableAssignedDialog"
      :target-date="targetDate"
      :target-driver-id="targetDriverId"
      @closeEvent="closeDriverAssignedDialogCallback"
    />
  </div>
</template>

<script>
import DriverScheduleDialog from '../dialogs/_DriverScheduleDialog'
export default {
  name: "WeekDayCell",
  components: {
    DriverScheduleDialog
  },
  mixins: [],
  props: {
    targetDriverId: {
      type: Number,
      default: () => null
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      enableAssignedDialog: false,
      targetDate: null,
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {
    /**
     * 一覧件数リンク クリックイベント
     * 割り当てられたアサインの一覧をダイアログで表示する.
     */
    dayCountClickEvent () {
      this.targetDate = this.item.date
      this.enableAssignedDialog = true
    },
    closeDriverAssignedDialogCallback () {
      this.enableAssignedDialog = false
    }
  }
}
</script>
